import React from 'react'
import { Container, Row, Col, Label, Input, Button } from 'reactstrap'
import '../../css/PopOverController.css'
import { Account } from '../../model/Account'
const {getUrl} = require('./../../model/request/pdf')
const {clientBaseUrl} = require('./../../model/request/url')

class EmailModalController extends React.Component{

    constructor(props) {
        super(props)

        const account = Account.fromCookieAndLocalStorage()
        const isCustomer = account.isCustomer()

        function makeBody(toName, fromName, body) {
            // return 'Hello ' + toName + '.\n' +
            return body + '\n' +
                'See attached pdf below or ' +
                'click the link here.\n' +
                clientBaseUrl + getUrl(props.quote, true) + '\n\n' +
                'From,\n' +
                fromName
        }

        if (props.quote) {
            this.state = {
                model: {
                    //'wmonks@asantesigngroup.com',
                    fromEmail: 'noreply@asantesigngroup.com',
                        // isCustomer ?
                        //     props.quote.contact_info.email :
                        //     props.quote.asante_contact_info.email,
                    toEmail: isCustomer ?
                            'jbradley@asantesigngroup.com' :
                            props.quote.contact_info.email,
                    ccEmail: isCustomer ?
                            props.quote.contact_info.email :
                            props.quote.asante_contact_info.email,
                    subject: props.quote.job_name,
                    body: makeBody(
                        isCustomer ?
                            'Jen Bradley' :
                            props.quote.contact_info.first_name +
                            ' ' + props.quote.contact_info.last_name,
                        isCustomer ?
                            props.quote.contact_info.first_name +
                            ' ' + props.quote.contact_info.last_name :
                            props.quote.asante_contact_info.first_name + ' ' +
                            props.quote.asante_contact_info.last_name,
                        props.quote.comments,
                    ),
                }
            }
        } else {
            this.state = {
                model: {
                    fromEmail: '',
                    toEmail: '',
                    ccEmail: '',
                    subject: '',
                    body: makeBody('', 'William Monks', ''),
                }
            }
        }

    }

    updateModelValue(key, value) {
        const model = this.state.model
        model[key] = value
        this.setState({
            'model': model
        })
    }

    sendEmail() {
        this.props.sendEmail(this.state.model)
    }

    makeRow(labelName, key) {

        return <>
            <Row style={{'marginTop': '8px'}}>
                <Col>
                    <Label>{labelName}</Label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Input
                        onChange={(e) => this.updateModelValue(key, e.target.value)}
                        value={this.state.model[key]} />
                </Col>
            </Row>
        </>
    }

    render() {
        if (this.props.hidden) {
            return <></>
        }

        return (
            <Container>
                <Row>
                    <Col>
                        <Label style={{
                            'fontSize': '20px',
                            'fontWeight': '500',
                        }}
                            >Email Report</Label>
                    </Col>
                </Row>
                {this.makeRow('From', 'fromEmail')}
                {this.makeRow('To', 'toEmail')}
                {this.makeRow('CC', 'ccEmail')}
                {this.makeRow('Subject', 'subject')}
                <Row style={{'marginTop': '8px'}}>
                    <Col>
                        <Label>Body</Label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Input
                            type="textarea"
                            style={{'width': '100%', 'minHeight': '115px'}}
                            onChange={(e) => this.updateModelValue('body', e.target.value)}
                            value={this.state.model.body} />
                    </Col>
                </Row>
                <Row>
                    <Col style={{'textAlign': 'right'}}>
                        <Button style={{
                            'marginTop': '8px',
                            'marginBottom': '8px'
                        }}
                            color='primary' onClick={(e) => this.sendEmail()}>Send</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export { EmailModalController }

